import { render, staticRenderFns } from "./bookKeepingForMink.vue?vue&type=template&id=69923096&scoped=true"
import script from "./bookKeepingForMink.vue?vue&type=script&lang=js"
export * from "./bookKeepingForMink.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_5cxdem7bu5cwsxatf4y6tpyoxu/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69923096",
  null
  
)

export default component.exports